module.exports = __webpack_public_path__ + "static/media/Orbit-envisat.3270a56e.png";